import { Component, Input, OnChanges } from '@angular/core';
import { Video } from '@emi/shared/models';

@Component({
    selector: 'via-video-player',
    templateUrl: './video-player.component.html',
    styleUrls: ['./video-player.component.scss'],
})
export class VideoPlayerComponent implements OnChanges {
    @Input() public video: Video;
    public isLoaded: boolean = false;

    public ngOnChanges(): void {
        this.isLoaded = false;
        setTimeout(() => (this.isLoaded = true), 0);
    }
}
